<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "CBProposalOverview",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>5. (i) What was the AVERAGE total value during the last 12 months of</div>"
					},
					bindTo: ""
				},
				{
					label:
						"(a) Your own stock and bank notes? (The stock figure is to be declared on the basis of cost price or on the basis as in question 4 above)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0StockBankNotesAverageValueId",
					props: {
						suggest: {
							typeIncludes: "stockBankNotesAverageValue"
						},
						createOptions: {
							type: "stockBankNotesAverageValue",
							dataType: "string"
						}
					}
				},
				{
					label:
						"(b) Goods in trust (other than for sale custody) goods on approval, repairs and the like?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0GoodsInTrustAverageValueId",
					props: {
						suggest: {
							typeIncludes: "goodsInTrustAverageValue"
						},
						createOptions: {
							type: "goodsInTrustAverageValue",
							dataType: "string"
						}
					}
				},
				{
					label: "The TOTAL under (a) and (b) comprises approximately",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0StockBankNotesGoodsInTrustSumValueId",
					props: {
						suggest: {
							typeIncludes: "stockBankNotesGoodsInTrustSumValue"
						},
						createOptions: {
							type: "stockBankNotesGoodsInTrustSumValue",
							dataType: "string"
						}
					}
				},
				{
					label: "Swallow's Nest",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0SwallowsNestValueId",
					props: {
						suggest: {
							typeIncludes: "swallowsNestValue"
						},
						createOptions: {
							type: "swallowsNestValue",
							dataType: "string"
						}
					}
				},
				{
					label: "Wine and Spirits",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0WineAndSpiritsValueId",
					props: {
						suggest: {
							typeIncludes: "wineAndSpiritsValue"
						},
						createOptions: {
							type: "wineAndSpiritsValue",
							dataType: "string"
						}
					}
				},
				{
					label: "Preserved Seafood",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0PreservedSeafoodValueId",
					props: {
						suggest: {
							typeIncludes: "preservedSeafoodValue"
						},
						createOptions: {
							type: "preservedSeafoodValue",
							dataType: "string"
						}
					}
				},
				{
					label: "Sundry Goods",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0SundryGoodsValueId",
					props: {
						suggest: {
							typeIncludes: "sundryGoodsValue"
						},
						createOptions: {
							type: "sundryGoodsValue",
							dataType: "string"
						}
					}
				},
				{
					label: "Cigar, Cigarette and Tobacco, Pipe and related goods",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0CigaretteAndRelatedGoodsValueId",
					props: {
						suggest: {
							typeIncludes: "cigaretteAndRelatedGoodsValue"
						},
						createOptions: {
							type: "cigaretteAndRelatedGoodsValue",
							dataType: "string"
						}
					}
				},
				{
					label:
						"5. (ii) What was the MAXIMUM value of your own stock and goods in trust (other than for safe custody) and bank notes at any time during the 12 months?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0StockBankNotesGoodsInTrustMaxValueId",
					props: {
						suggest: {
							typeIncludes: "stockBankNotesGoodsInTrustMaxValue"
						},
						createOptions: {
							type: "stockBankNotesGoodsInTrustMaxValue",
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
